import React, { useContext } from 'react'
import { observer } from 'mobx-react'

// Pages
import { AdminDashboard } from '../AdminDashboard'
import { OrganizationDashboard } from '../OrganizationDashboard'

// Store
import { UserStoreContext } from '../../stores/UserStore'

/**
 *
 * PortalDashboard
 *
 * The portal's single entry point.
 *
 * Organizers and exhibitors used to land on separate organization-scoped dashboards,
 * which meant the URL picked a company before the user picked anything. Since the event
 * list spans every organization a user belongs to (EXEC-1550), both dashboards showed
 * the same list and the organization in the path meant nothing — so there is one
 * dashboard now, and a mix of organizer and exhibitor roles needs no special handling.
 *
 * EE users keep their own dashboard, which is about the whole system rather than one
 * person's events.
 */
const PortalDashboard = observer(() => {
  const { isEEUser } = useContext(UserStoreContext)

  return isEEUser ? <AdminDashboard /> : <OrganizationDashboard />
})

export default PortalDashboard
